import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MobilePopupService {

    public open = new Subject();
    public answer = new Subject();

    constructor() {
    }

    openPopup(data): void {
        this.open.next(data);
    }
}
